import { motion } from "framer-motion";

import { cx } from "../../Utils/helpers";

/**
 * Single button primitive for the whole site.
 * Renders <a> when `href` is passed, otherwise <button>.
 *
 * <Button variant="primary" icon={<ArrowRight size={18} />}>Get started</Button>
 */
function Button({
  children,
  variant = "primary",
  size = "md",
  href,
  icon,
  iconPosition = "right",
  block = false,
  onDark = false,
  className,
  ...rest
}) {
  const classes = cx(
    "btn",
    `btn--${variant}`,
    size !== "md" && `btn--${size}`,
    block && "btn--block",
    onDark && "btn--on-dark",
    className
  );

  const content = (
    <>
      {icon && iconPosition === "left" && <span className="btn__icon">{icon}</span>}
      <span>{children}</span>
      {icon && iconPosition === "right" && <span className="btn__icon">{icon}</span>}
    </>
  );

  const motionProps = {
    whileHover: { y: -2 },
    whileTap: { scale: 0.97 },
    transition: { type: "spring", stiffness: 420, damping: 24 },
  };

  if (href) {
    return (
      <motion.a href={href} className={classes} {...motionProps} {...rest}>
        {content}
      </motion.a>
    );
  }

  return (
    <motion.button type="button" className={classes} {...motionProps} {...rest}>
      {content}
    </motion.button>
  );
}

export default Button;
